// extracted by mini-css-extract-plugin
module.exports = {"averageRatingBadge":"averageRatingBadge_8crit","emoji":"emoji_dzz5n","sessions":"sessions_5zkg5"};